export const LOCKDESK_MODAL_STATUS_TITLES = {
  open: 'Lock Desk is open. All times are Eastern Time (ET).',
  close: 'Lock Desk is closed. All times are Eastern Time (ET).',
  openONRP:
    'Lock Desk is closed but Overnight Rate Protection is available. All times are Eastern Time (ET).',
};
